import React, { useState } from 'react'
import { useCountContext } from "../../utils/global";
import api from '../../utils/api'
import emailjs from 'emailjs-com'
import './style.css'


function Index() {
  const [, dispatch] = useCountContext();
  const [state, setState] = useState({
    phone: '',
    company: '',
    name: "",
    email: "",
    message: ""
  });
  let timeRemaining = 3;
  const [time, setTime] = useState(3)
  const [message, setMessage] = useState({
    message: 'none',
    form: 'block'
  })
  function handleContact() {
    dispatch({
      type: 'contact'
    })
  }
  function handleInputChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    setState({
      ...state,
      [name]: value
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    clearForm();
    const email = {
      body: {
        name: state.name,
        company: state.company,
        phone: state.phone,
        email: state.email,
        message: state.message
      }
    }
    emailjs.sendForm('service_2fo937x', 'template_tdho3wc', event.target, 'user_exOJ3ZTFpQ5aLuZGZojaz')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
    // api.sendEmail(email);
    setMessage({
      message: 'block',
      form: 'none'
    });

    const myInterval = setInterval(() => {
      if (timeRemaining > 0) {
        timeRemaining = timeRemaining - 1;
        setTime(timeRemaining);
      } else {
        clearInterval(myInterval);
        dispatch({ type: "contact" });
      }
    }, 1000);
  }
  function clearForm() {
    setState({
      name: "",
      email: "",
      company: "",
      phone: "",
      message: ""
    })
  }
  return (
    <div >
      <div className="dialogWindow" style={{ "display": message.message }}>
        <p>Thank you for your message</p>
        <p>Redirecting in <span>{time}</span> seconds</p>
        <p>Have a nice day!</p>
      </div>

      <form onSubmit={handleSubmit} style={{ display: message.form }} >
        <p><span className='fas fa-mobile-alt' /> 0447 281 498</p>
        <p><span className='far fa-envelope' /> msavantfou@gmail.com</p>
        <input
          value={state.name}
          type="text"
          name="name"
          placeholder="name"
          onChange={handleInputChange}
        />
        <input
          value={state.email}
          type="text"
          name="email"
          placeholder="email"
          onChange={handleInputChange}
        />
        <input
          value={state.company}
          type="text"
          name="company"
          placeholder="company"
          onChange={handleInputChange}
        />
        <input
          value={state.phone}
          type="text"
          name="phone"
          placeholder="phone number"
          onChange={handleInputChange}
        />
        <textarea
          value={state.message}
          name="message"
          placeholder="Leave me a message..."
          onChange={handleInputChange}
        ></textarea>
        <button className='formButton' onClick={handleContact} >Cancel</button>
        <input className='submitButton formButton' type='submit' value='Submit' />
      </form>
    </div>

  )
}

export default Index
